import React, { Component } from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';

class TableList extends Component {
  render() {
    const {
      bordered = true,
      columns,
      dataSource,
      pagination,
      rowClass,
      rowID,
      totalItem,
      changePage,
      loadingValue,
      currentPage,
      scrollX,
      emptyText,
      pageSize,
      customEmptyText = null,
      ...other
    } = this.props;
    let paginationValue = false;
    let rowClassData = '';
    let scroll;
    let locale;

    const loadingValueParam = loadingValue || false;

    if (rowClass) {
      rowClassData = rowClass;
    }

    if (scrollX) {
      scroll = { x: scrollX };
    }

    if (pagination !== '') {
      paginationValue = {
        showLessItems: true,
        total: totalItem,
        onChange: changePage,
        pageSize: pageSize || 10,
      };
    }

    if (currentPage) {
      paginationValue = {
        ...paginationValue,
        current: currentPage,
      };
    }

    if (emptyText) {
      if (customEmptyText) {
        locale = {
          emptyText: <p className="ant-empty-description">{emptyText}</p>,
        };
      } else {
        locale = {
          emptyText: (
            <div className="ant-empty ant-empty-normal">
              <div className="ant-empty-image">
                <img
                  alt="No Data"
                  src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA2NCA0MSIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
                />
              </div>
              <p className="ant-empty-description">{emptyText}</p>
            </div>
          ),
        };
      }
    }

    return (
      <div style={{ borderTop: bordered ? 'solid 1px #e8e8e8' : 'none' }}>
        <Table
          rowKey={rowID}
          columns={columns}
          dataSource={dataSource}
          pagination={paginationValue}
          rowClassName={rowClassData}
          loading={loadingValueParam}
          scroll={scroll}
          locale={locale}
          {...other}
        />
      </div>
    );
  }
}

TableList.propTypes = {
  columns: PropTypes.array.isRequired,
  dataSource: PropTypes.array,
  pagination: PropTypes.string,
  rowClass: PropTypes.string,
  rowID: PropTypes.func,
  totalItem: PropTypes.number,
  changePage: PropTypes.func,
  loadingValue: PropTypes.bool,
  scrollX: PropTypes.number,
  currentPage: PropTypes.number,
  emptyText: PropTypes.string,
  pageSize: PropTypes.number,
  customEmptyText: PropTypes.bool,
  bordered: PropTypes.bool,
};

export default TableList;
